<!-- <app-header-one [sticky]="true"></app-header-one> -->
<app-header-latest></app-header-latest>
<section  class="section-b-space">
 
  <!-- <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search</mat-label>
    <input matInput placeholder="Search">
    <button mat-icon-button matSuffix color="orange">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field> -->

  <div class="container">
    <div *ngIf="jobs?.length === 0" style="text-align: center;" class="text-center text-danger my-3">
    <p><b>No jobs available</b></p>
  </div>
    <div class="card-container">
      <div class="job-card" *ngFor="let job of jobs; let i = index" style="border-left-color: #BF0000;cursor: pointer;" (click)="goToDetails(job)">
        <div class="row" >
          <div class="col-md-3">
            <div class="logo-container">
              <img [src]="getLogoUrl(job)" alt="Job Logo" class="logo img-fluid" width="60" height="30"/>
            </div>
          </div>
          <div class="col-md-8">
            <h2 class="job-company-name">{{ job.job_title }}</h2>
            <!-- <p class="job-title">&#64;{{ job.job_title }}</p> -->
          </div>
          <div class="col-md-1">
            <div class="bookmark">
              <!-- <img src="assets/images/job-card-icons/bookmark.png" class="img-fluid"/> -->
              <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#bf0000" fill="none">
                <path d="M11 2C7.22876 2 5.34315 2 4.17157 3.12874C3 4.25748 3 6.07416 3 9.70753V17.9808C3 20.2867 3 21.4396 3.77285 21.8523C5.26947 22.6514 8.0768 19.9852 9.41 19.1824C10.1832 18.7168 10.5698 18.484 11 18.484C11.4302 18.484 11.8168 18.7168 12.59 19.1824C13.9232 19.9852 16.7305 22.6514 18.2272 21.8523C19 21.4396 19 20.2867 19 17.9808V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 7H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M17 10L17 2M13 6H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg> -->
            </div>
          </div>
         </div>

         
        <hr class="break-line">
        <div class="row">
          <div class="col-lg-12">&nbsp;</div>
        </div>
    
        <div class="card-content">
          <div class="row">
           <div class="col-md-8">
            <p style="font-size: 20px; color:black" class="location-info" [ngClass]="{'text-wrap': job.job_location.split(' ').length > 3}">
              <!-- <i class="pi pi-building"></i> -->
              {{ job.job_location }}
            </p>
           </div>
           <div class="col-md-4">
            <p style="font-size: 14px; color: #596574;">
              <!-- <i class=" pi pi-briefcase" aria-hidden="true"></i> -->
             Job Type : {{ job.job_type === "F" ? "Fresher" : "Experienced" }}
            </p>
          </div>

            <!-- icons and text this is the main and previous design -->
            <!-- <div class="col-xl-10">
              <div class="text-container">
                <div class="row">
                  <div class="col-md-6">
                    <p style="font-size: 14px;">
                      <i class=" pi pi-briefcase" aria-hidden="true"></i>
                      {{ job.job_type === "F" ? "Fresher" : "Experienced" }}
                    </p>
                  </div>

                  <div class="col-md-6">
                    <p style="font-size: 14px;">
                      <i class="pi pi-wallet"></i>
                      {{ job.min_salary }}{{ job.salary_type }}-{{ job.max_salary}}{{ job.salary_type }}
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <p style="font-size: 14px;">
                      <i class="pi pi-users"></i>
                      {{ job.no_of_positions }}
                    </p>
                  </div>

                  <div class="col-md-6">
                    <p style="font-size: 14px;" class="location-info" [ngClass]="{'text-wrap': job.location.split(' ').length > 3}">
                      <i class="pi pi-building"></i>
                      {{ job.location }}
                    </p>
                  </div>
                  
                </div>
              </div>
            </div>     -->

           
          </div>

          <div class="row">
            <div class="col-md-8">
              <p style="font-size: 14px; color: black;">
                Application Link: 
                <a [href]="job.application_link" target="_blank" rel="noopener noreferrer" style="color: #bf0000; text-decoration: underline;">
                  {{ job.application_link }}
                </a>
              </p>
            </div>
           <!--  <div class="col-md-8">
              <p style="font-size: 14px; color: black;">
               Application Link : {{ job.application_link }}
              </p>
            </div> -->
            <div class="col-md-4">
              <p style="font-size: 14px; color: #596574">
                Job Category : {{ job.job_category }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <p style="font-size: 14px; color: black;">
                ₹{{ job.min_pay_range }}{{ job.salary_type }}- ₹{{ job.max_pay_range}}{{ job.salary_type }} LPA
              </p>
            </div>
            <div class="col-md-4">
              <p style="font-size: 14px; color: #596574">
                Job start date : {{ job.job_start_date | date:'MMM d, y' }}
              </p>
            </div>
           
            <!-- <div class="col-md-3">
              <p style="font-size: 14px; color: #596574">
                Job end date :{{ job.job_end_date }}
              </p>
            </div> -->
          </div>
          <div class="row">
            <div class="col-md-8">
              <p style="font-size: 14px; color: black;">
                Required Skills: {{ job.required_skills }}
              </p>
            </div>
            <div class="col-md-4">
              <p style="font-size: 14px; color: #596574">
                Job end date : {{ job.job_end_date | date:'MMM d, y' }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 apply-button">
              <button class="btn-solid">Fulltime</button>
            </div>
            <div class="col-xl-2 apply-button">
              <button class="btn-solid">Remote</button>
            </div>
            <!-- <div class="col-xl-2 apply-button">
              <button class="btn-solid" (click)="appDownload()">Apply</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container">
    <div class="card-container">
      <div class="job-card" *ngFor="let job of jobs; let i = index" style="border-left-color: #BF0000;cursor: pointer;" (click)="goToDetails(job)">
        <div class="offers-container">
          <h2>TRENDING OFFERS</h2>
          <button class="view-all" style="float:right">View All</button>
          <div class="offers-wrapper">
            <div *ngFor="let offer of offers" class="offer-card" [ngStyle]="{'background': offer.bgColor}">
              <div class="offer-badge">
                <img [src]="offer.icon" alt="Offer Icon" />
              </div>
              <p class="offer-category">{{ offer.category }}</p>
              <h3 class="offer-title">{{ offer.title }}</h3>
              <p class="offer-validity">Valid till {{ offer.validity }}</p>
              <div class="offer-code">
                <span>{{ offer.code }}</span>
                <i class="copy-icon">📋</i>
              </div>
            </div>
          </div>
         
        </div>
        
      </div>
    </div>
  </div> -->
</section>

<!-- <app-footer-one></app-footer-one> -->
<app-footer-more-info></app-footer-more-info>